import React from 'react'
import useAppDispatch from './useAppDispatch'
import useAllApiCall from './useAllApiCall';
import useReduxData from './useReduxData';
import { SETSELECTEDSTORE } from '../redux/features/store';
const useChangeStore = () => {
    const reduxData = useReduxData();
    const { storeChangeSelection } = useAllApiCall();


    const dispatch = useAppDispatch();

    const resetStore = () => {
        dispatch(SETSELECTEDSTORE({}));
        dispatch({ type: 'RESET_STORE_SELECTION' });
    }

    const changeStore = (storeId: any) => {
        let allStore = reduxData.store.allStore;
        // let selectedStoreId = reduxData.store.selectedStore?.store_id || sessionStorage.getItem("store-id") || "";
        sessionStorage.removeItem("store");
        resetStore();
        storeChangeSelection(allStore, storeId);
    }
    return { changeStore, resetStore }
}

export default useChangeStore